/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';

// 🤯 https://fettblog.eu/typescript-union-to-intersection/

export function useStateMachine(initialState, machine) {
  return React.useReducer(function (state, event) {
    var nextState = machine[state][event];
    return nextState !== null && nextState !== void 0 ? nextState : state;
  }, initialState);
}